<template>
  <section>
    <div v-if="loading">
      <div class="grid grid-cols-12 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-12">
          <div class="intro-y box">
            <div
              class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
            >
              <h2 class="font-medium text-base mr-auto">Editar Corte</h2>
              <div class="form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0">
                Creada por:<label
                  class="form-check-label ml-0 sm:ml-2"
                  for="show-example-1"
                  >{{ email.user_created.name }} - {{ email.created_at }}
                </label>
              </div>
            </div>
            <form
              class="intro-y grid grid-cols-12 gap-3 p-5"
              @submit.prevent="updateEmail"
            >
              <div class="col-span-6 sm:col-span-6 xxl:col-span-12">
                <label for="msg">Nombre</label>
                <input
                  v-on:input="updateValue('name', $event)"
                  type="text"
                  class="input w-full border mt-2"
                  :value="email.name"
                />
              </div>
              <div class="col-span-3 sm:col-span-3 xxl:col-span-12">
                <label for="msg">Numero de Pieza(s)</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('number', $event)"
                  :v-model="email.number"
                  required
                >
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="num in nums" :value="num">
                    {{ num }}
                  </option>
                </select>
              </div>
              <div class="col-span-3 sm:col-span-3 xxl:col-span-12">
                <label for="msg">Fecha de entrega</label>
                <input
                  v-on:input="updateValue('date', $event)"
                  type="date"
                  class="input w-full border mt-2"
                  :value="email.date"
                />
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('project_id', $event)"
                  :v-model="aux_email.project_id"
                  required
                >
                  <option disabled>Seleccione...</option>
                  <option v-for="project in projects" :value="project.id">
                    {{ project.name }} - {{ project.account.name }}
                    {{ project.account.country.prefix }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2"
                  @input="updateValue('campaign_id', $event)"
                  :value="aux_email.campaign_id"
                  required
                >
                  <option value="">Seleccione la campaña</option>
                  <option
                    v-for="campaign in filteredCampaigns"
                    :value="campaign.id"
                  >
                    {{ campaign.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label for="msg">Estado</label>
                <select
                  class="input w-full border mt-2"
                  v-on:input="updateValue('state_id', $event)"
                  :value="email.state_id"
                  required
                >
                  <option disabled>Seleccione el estado</option>
                  <option v-for="state in states" v-bind:value="state.id">
                    {{ state.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3 col-span-4 sm:col-span-4 xxl:col-span-6">
                <label>Usuario</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-on:input="updateValue('user_id', $event)"
                  :value="email.user_id"
                  required
                >
                  <option disabled>Seleccione el usuario</option>
                  <option v-for="user in filteredUsers" v-bind:value="user.id">
                    {{ user.name }}
                  </option>
                </select>
              </div>
              <div class="my-3 col-span-4 sm:col-span-4">
                <label>Url Archivo</label>
                <input
                  v-on:input="updateValue('path', $event)"
                  type="text"
                  class="input w-full border mt-2"
                  :value="email.path"
                  required
                />
              </div>
              <div class="my-3 col-span-4 sm:col-span-4">
                <label>Url Respuesta</label>
                <input
                  v-on:input="updateValue('response', $event)"
                  type="text"
                  class="input w-full border mt-2"
                  :value="email.response"
                />
              </div>
              <div class="mt-3 col-span-12">
                <button
                  type="submit"
                  id="edit"
                  class="button w-24 bg-theme-1 text-white"
                >
                  Modificar
                </button>
              </div>
            </form>

            <div v-if="email.versions.length">
              <div
                class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
              >
                <h2 class="font-medium text-base mr-auto">Versiones</h2>
              </div>
              <div
                class="grid grid-cols-12 items-center p-5 border-b border-gray-200"
                v-for="version in email.versions"
              >
                <div class="col-span-6 mt-3 lg:mt-0">
                  {{ version.observations }}
                  <div class="text-gray-600 text-xs">
                    {{ version.created_at }}
                  </div>
                  <a v-if="version.path" :href="version.path" target="_blank"
                    >Abrir Url</a
                  >
                </div>
                <div
                  class="col-span-6 mt-3 lg:mt-0"
                  v-if="version.response_observations"
                >
                  {{ version.response_observations }}
                  <div class="text-gray-600 text-xs">
                    {{ version.updated_at }}
                  </div>
                  <a
                    v-if="version.response_path"
                    :href="version.response_path"
                    target="_blank"
                    >Abrir Url</a
                  >
                </div>
                <div class="col-span-6 mt-3 lg:mt-0" v-else>
                  <form
                    class="intro-y gap-3"
                    @submit.prevent="updateVersion(version)"
                  >
                    <div class="col-span-6 sm:col-span-6">
                      <label>Descripcion</label>
                      <textarea
                        class="input w-full border mt-2"
                        rows="1"
                        v-model="version_current.response_observations"
                        required
                      ></textarea>
                    </div>
                    <div class="col-span-6 sm:col-span-6">
                      <label>Url Archivo (opcional)</label>
                      <input
                        type="text"
                        class="input w-full border mt-2"
                        v-model="version_current.response_path"
                      />
                    </div>
                    <div class="mt-3 col-span-12 sm:col-span-12">
                      <button
                        type="submit"
                        id="editversion"
                        class="button bg-theme-1 text-white"
                      >
                        Responder
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <form
              class="intro-y grid grid-cols-12 gap-3 p-5"
              @submit.prevent="createVersion"
            >
              <div class="col-span-5 sm:col-span-5">
                <label>Descripcion</label>
                <textarea
                  class="input w-full border mt-2"
                  rows="1"
                  v-model="version.observations"
                  required
                ></textarea>
              </div>
              <div class="col-span-4 sm:col-span-4">
                <label>Url Archivo (opcional)</label>
                <input
                  type="text"
                  class="input w-full border mt-2"
                  v-model="version.path"
                />
              </div>
              <div class="mt-8 col-span-3 sm:col-span-3">
                <button
                  type="submit"
                  id="create"
                  class="button bg-theme-1 text-white"
                >
                  Crear Nueva Version
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'EditEmail',
  data() {
    return {
      loading: false,
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      view: {
        entity: 'email',
        id: this.$route.params.id,
      },
      version: {
        entity: 'emailversion',
        observations: '',
        path: '',
      },
      aux_email: {
        entity: 'email',
        campaign_id: null,
        project_id: null,
      },
      version_current: {
        entity: 'emailversion',
      },
    }
  },
  computed: {
    ...mapGetters({
      email: 'getEmail',
      campaigns: 'getCampaigns',
      teams: 'getTeams',
      states: 'getEmailStates',
      users: 'getUsers',
      projects: 'getProjects',
    }),
    filteredCampaigns() {
      let campaigns = this.campaigns.filter((v) => {
        return v.project_id == this.aux_email.project_id
      })

      const found = campaigns.some(
        (el) => el.id == this.aux_email['campaign_id']
      )
      if (this.email && !found) {
        this.aux_email['campaign_id'] = ''
      }
      return campaigns
    },
    filteredUsers() {
      return this.users.filter((v) => {
        return v.team_id == 1
      })
    },
  },
  async beforeMount() {
    try {
      await this.show(this.view)
      this.getList('project')
      this.getList('campaign')
      this.getList('emailstate')

      this.aux_email['campaign_id'] = this.email.campaign_id
      this.aux_email['project_id'] = this.email.project_id

      this.loading = true
    } catch (error) {}
  },
  methods: {
    updateEmail() {
      var vm = this
      vm.loading = false
      window.$('#edit').button('loading')
      vm.aux_email.id = this.email.id
      vm.update(vm.aux_email)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/emails'
          )
        })
        .catch((message) => {
          window.$('#edit').button('reset')
          vm.loading = true
        })
    },
    createVersion() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.version.email_id = this.email.id
      vm.store(vm.version)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/emails'
          )
        })
        .catch((message) => {
          window.$('#create').button('reset')
          vm.loading = true
        })
    },
    updateVersion(item) {
      var vm = this
      vm.loading = false
      window.$('#editversion').button('loading')
      vm.version_current.id = item.id
      vm.store(vm.version_current)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/emails'
          )
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
          vm.loading = true
        })
    },
    updateValue(attribute, e) {
      this.aux_email[attribute] = e.target.value
    },
    ...mapActions(['show', 'getAll', 'getList', 'update', 'store']),
  },
  components: {
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// EditEmail.vue?75e48848